import _plugin_vue_export_helper_default from "../_virtual/_plugin-vue_export-helper.js";
import PaymentSection_vue_vue_type_script_setup_true_lang_default from "./PaymentSection.vue.script.js";
/* empty css                             */
//#region src/components/PaymentSection.vue
var PaymentSection_default = /*#__PURE__*/ _plugin_vue_export_helper_default(PaymentSection_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-9d163ea1"]]);
//#endregion
export { PaymentSection_default as default };

//# sourceMappingURL=PaymentSection.vue.js.map